import React, { useState, useEffect } from "react";
import vozoExploreIcon from "../../assets/images/vozo-explore-icon.png";
import { Div } from "./styles";
import { Modal } from "react-bootstrap";
import UserGuide from "../popups/UserGuide";
import { Decrypt_Value } from "../../MiddleWare/EncryptDecrypt/index.js";
import { useHistory, useLocation } from "react-router-dom";
import headphoneIcon from "../../assets/images/Headphone.svg";
import monitorIcon from "../../assets/images/mdi_television.svg";

const ExploreWidget = ({ explore }) => {
  //------------------------------------------State and Variables Start------------------------------------------//

  const [showuserguide, setshowuserguide] = useState(false);
  const provname = localStorage.getItem("provider_name")
    ? Decrypt_Value(localStorage.getItem("provider_name"), "vozo")
    : "";
  const expired_days = localStorage.getItem("expired_days")
    ? Decrypt_Value(localStorage.getItem("expired_days"), "vozo")
    : "";
  const location = useLocation();
  let history = useHistory();

  //------------------------------------------State and Variables End------------------------------------------//
  // ------------------------------- Functions Start--------------------------------------------------------- //

  const handleCloseApp = () => setshowuserguide(false);
  // ------------------------------- Functions End--------------------------------------------------------- //
  useEffect(() => {
    if (location?.state?.getstartedopen === true) {
      setshowuserguide(true);
      history.replace({ ...location, state: {} });
    }
  }, [location?.state?.getstartedopen]);

  useEffect(() => {
    const handleOpenUserGuide = () => setshowuserguide(true);
    window.addEventListener("openUserGuidePopup", handleOpenUserGuide);

    return () => {
      window.removeEventListener("openUserGuidePopup", handleOpenUserGuide);
    };
  }, []);
  return (
    <>
      <Div className={explore}>
        <img
          src={headphoneIcon}
          className="explore-vozo-img"
          alt="support"
          style={{ marginTop: "6px", marginRight: "6px" }}
        />
        <h1
          className="explore-vozo-heading"
          style={{
            marginTop: "-20px",
            fontWeight: 600,
          }}
        >
          Need Assistance?
        </h1>
        <p
          className="explore-vozo-para"
          style={{ marginLeft: " 12px", marginRight: "0px" }}
        >
          Our team helps you configure everything
        </p>
        <button
          className="explore-vozo-button"
          onClick={() => {
            window.open(
              "https://calendar.app.google/WdCM1sN5Fg4Es1qm9",
              "_blank",
            );
          }}
          disabled={expired_days < 0}
        >
          Get Support
        </button>
      </Div>

      {explore === "explore-vozo-widget" && (
        <div
          className="explore-vozo-secondary-wrapper"
          style={{
            marginTop: "-32px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <button
            className="explore-vozo-secondary-button"
            onClick={() => {
              setshowuserguide(true);
              history.push({
                pathname: location.pathname,
                state: { patientportalstarted: false },
              });
            }}
            disabled={expired_days < 0}
            style={{
              width: "100%",
              maxWidth: "420px",
              background: "#fff",
              border: "1px solid #2C7BE5",
              borderRadius: "10px",
              padding: "6px 26px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
              fontSize: "14px",
              fontWeight: 400,
              color: "#2C7BE5",
              marginBottom: "6px",
            }}
          >
            <img
              src={monitorIcon}
              className="explore-vozo-secondary-icon"
              alt=""
            />
            Explore Vozo
          </button>
        </div>
      )}
      <Modal
        style={{
          zIndex: 9999,
        }}
        // className="zIndex1100"
        show={showuserguide}
        onHide={() => setshowuserguide(false)}
      >
        <UserGuide close={handleCloseApp} ProviderName={provname} />
      </Modal>
    </>
  );
};

export default ExploreWidget;
